import sx from '@styled-system/css';
import { jsx } from 'theme-ui';
import Button, { ButtonProps, Ghost, Link } from './components/button';
import Input, { InputProps } from './components/input';
import Selectable from './components/selectable';
import View, { ViewProps } from './components/view';
import Text, { styles as textVariants, TextProps } from './components/text';
import { Logo, Lockup } from './components/branding';
import ThemeProvider, { Theme, useTheme, theme } from './components/theme';

export {
  Button,
  Logo,
  Selectable,
  Input,
  InputProps,
  Lockup,
  Ghost as GhostButton,
  Link as LinkButton,
  View,
  Text,
  textVariants,
  useTheme,
  theme,
  ThemeProvider,
  ThemeProvider as Monterey,
  jsx,
  sx,
  ButtonProps,
  ViewProps,
  TextProps,
  Theme,
};
